module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ehS061/images/cover.jpg?1692135101141",
      "alt": "This image is the cover for the book Unfinished Business, Beggars and Choosers and Unfinished Business"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unfinished Business, Beggars and Choosers and Unfinished Business\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Sequel to Beggars and Choosers")])])]), _c('p', [_vm._v("After struggling through dishonesty, betrayal, and the kind of pasts they’d like to leave behind them, Brett Taylor and Cory Butana are back together and starting to build a new life. Brett has a good job. Cory has started college. But not everything goes the way they planned.")]), _vm._v(" "), _c('p', [_vm._v("Still recovering from the emotional and physical repercussions of a brutal assault, Cory finds himself trapped by his own insecurity and fear, unable to believe that his heart is safe with Brett or that his body is safe without him. On the other hand, Brett has total faith in Cory’s love and commitment, even though he still struggles with his own ghosts.")]), _vm._v(" "), _c('p', [_vm._v("With girls flocking to Brett’s side and a wannabe-lover lab partner feeding his doubts, Cory can’t find a way to tell Brett about the unfinished business that haunts him. If Brett wants to save him, he’ll have to see through Cory’s deception in time.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mia Kerick\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0